import { config } from "config/config";
import { isYeloAppSession } from "utils/partnerSession.util";
import { getStoredPartnerUser } from "utils/partnerUser.util";

const NON_PROD_APP_ENVS = new Set([
  "development",
  "dev",
  "test",
  "testing",
  "staging",
  "qa",
]);

/** Mixpanel + booking funnel — Yelo mobile app webview only (not staging/QA/local). */
export function shouldEnableYeloAppAnalytics(): boolean {
  if (process.env.REACT_APP_DISABLE_ANALYTICS === "true") {
    return false;
  }

  const env = (config.APP_ENV || config.NODE_ENV || "").toLowerCase();
  if (NON_PROD_APP_ENVS.has(env)) {
    return false;
  }

  if (!config.MIXPANEL_TOKEN) {
    return false;
  }

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return false;
    }
  }

  return isYeloAppSession();
}

export function yeloAppAnalyticsUserId(): string {
  const user = getStoredPartnerUser();
  const id = user?.user_id || user?.external_user_id;
  return id != null ? String(id) : "";
}

export function yeloAppAnalyticsBaseProps(
  screen: string
): Record<string, unknown> {
  return {
    screen,
    partner_source: "yelo_app",
    user_id: yeloAppAnalyticsUserId(),
    timestamp: Date.now(),
    path: typeof window !== "undefined" ? window.location.pathname : "",
  };
}

/** @deprecated Use shouldEnableYeloAppAnalytics */
export const shouldEnablePartnerAnalytics = shouldEnableYeloAppAnalytics;
